/* Scenty CRO - scroll animations, social proof, exit intent, CTA tracking */
(function () {
  'use strict';

  var STICKY_BOTTOM = 'calc(var(--sc-sticky-offset, 0px) + 16px)';

  /* ── Scroll reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('.sc-reveal');
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sc-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ── CTA click tracking ── */
  function initCtaTracking() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.sc-track-cta');
      if (!link) return;
      var payload = {
        event: 'scenty_cta_click',
        cta_location: link.getAttribute('data-cta') || 'unknown',
        cta_href: link.getAttribute('href') || '',
        page_path: window.location.pathname
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
      document.dispatchEvent(new CustomEvent('scenty:cta', { detail: payload }));
    });
  }

  /* ── Social proof notification ── */
  var proofMessages = [
    { name: 'Maria fra Aarhus', action: 'startede abonnement', time: '2 min. siden' },
    { name: 'Kasper fra København', action: 'valgte Tom Ford', time: '5 min. siden' },
    { name: 'Julie fra Odense', action: 'startede abonnement', time: '8 min. siden' },
    { name: 'Anders fra Aalborg', action: 'valgte Dior Sauvage', time: '11 min. siden' },
    { name: 'Sofie fra Esbjerg', action: 'startede abonnement', time: '14 min. siden' },
    { name: 'Lars fra Roskilde', action: 'valgte YSL Black Opium', time: '17 min. siden' }
  ];

  function createProofToast(msg) {
    var toast = document.createElement('div');
    toast.className = 'sc-proof-toast';
    toast.innerHTML =
      '<div class="sc-proof-toast__avatar">' + msg.name.charAt(0) + '</div>' +
      '<div class="sc-proof-toast__body">' +
        '<div class="sc-proof-toast__name">' + msg.name + '</div>' +
        '<div class="sc-proof-toast__action">' + msg.action + '</div>' +
        '<div class="sc-proof-toast__time">' + msg.time + '</div>' +
      '</div>';
    return toast;
  }

  function injectProofStyles() {
    if (document.getElementById('sc-proof-toast-styles')) return;
    var s = document.createElement('style');
    s.id = 'sc-proof-toast-styles';
    s.textContent = [
      '.sc-proof-toast{',
        'position:fixed;bottom:' + STICKY_BOTTOM + ';left:16px;z-index:8999;',
        'display:flex;align-items:center;gap:10px;',
        'background:#FFFFFF;',
        'border:1px solid #E2DBD2;',
        'border-radius:12px;',
        'padding:12px 16px;',
        'box-shadow:0 8px 24px rgba(0,0,0,0.12);',
        'font-family:"Inter",-apple-system,sans-serif;',
        'max-width:260px;',
        'transform:translateX(-120%);',
        'transition:transform 400ms cubic-bezier(0.22,1,0.36,1), bottom 300ms ease;',
        'pointer-events:none;',
      '}',
      '.sc-proof-toast.show{transform:translateX(0);}',
      '.sc-proof-toast__avatar{',
        'width:34px;height:34px;border-radius:50%;',
        'background:linear-gradient(135deg,#C5A87A,#8A6E48);',
        'color:#0D0C0B;font-size:14px;font-weight:600;',
        'display:flex;align-items:center;justify-content:center;flex-shrink:0;',
      '}',
      '.sc-proof-toast__body{min-width:0;}',
      '.sc-proof-toast__name{font-size:12px;font-weight:600;color:#1A1816;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
      '.sc-proof-toast__action{font-size:11px;color:#7A756E;margin-top:1px;}',
      '.sc-proof-toast__time{font-size:10px;color:#C5A87A;margin-top:2px;letter-spacing:0.04em;}',
      '@media(max-width:480px){.sc-proof-toast{max-width:220px;left:12px;}}',
    ].join('');
    document.head.appendChild(s);
  }

  function showProofToasts() {
    if (window.innerWidth < 1100) return;
    if (sessionStorage.getItem('sc_proofs_shown')) return;

    injectProofStyles();
    var container = document.body;
    var idx = 0;

    function showNext() {
      if (idx >= proofMessages.length) {
        sessionStorage.setItem('sc_proofs_shown', '1');
        return;
      }
      var toast = createProofToast(proofMessages[idx]);
      container.appendChild(toast);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.classList.add('show');
        });
      });
      setTimeout(function () {
        toast.classList.remove('show');
        setTimeout(function () {
          if (toast.parentNode) toast.parentNode.removeChild(toast);
          idx++;
          setTimeout(showNext, 12000 + Math.random() * 8000);
        }, 500);
      }, 4500);
    }

    setTimeout(showNext, 14000);
  }

  /* ── Exit intent popup ── */
  function isAccountLoggedIn() {
    if (document.body.classList.contains('scenty-customer-logged-in')) return true;
    if (document.body.classList.contains('scenty-recharge-page')) return true;
    return document.cookie.split(';').some(function (c) {
      var name = c.trim().split('=')[0];
      return name === 'recharge_portal_session' || name === 'recharge_session';
    });
  }

  function initExitIntent() {
    if (isAccountLoggedIn()) return;
    if (sessionStorage.getItem('sc_exit_shown')) return;
    if (window.innerWidth < 768) return;

    var triggered = false;
    var pricingUrl = '/collections/abonnementer';

    function injectPopup() {
      var overlay = document.createElement('div');
      overlay.id = 'sc-exit-overlay';

      var s = document.createElement('style');
      s.textContent = [
        '#sc-exit-overlay{position:fixed;inset:0;z-index:99000;background:rgba(13,12,11,0.6);',
          'display:flex;align-items:center;justify-content:center;padding:20px;',
          'animation:scFadeIn 250ms ease both;}',
        '#sc-exit-modal{background:#F8F5F0;border-radius:24px;padding:48px;max-width:480px;width:100%;',
          'text-align:center;position:relative;animation:scSlideUp 350ms cubic-bezier(0.22,1,0.36,1) both;}',
        '#sc-exit-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border:none;background:rgba(0,0,0,0.06);',
          'border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#7A756E;}',
        '.sc-exit-badge{display:inline-block;background:#C5A87A;color:#0D0C0B;font-size:11px;font-weight:700;',
          'letter-spacing:0.1em;text-transform:uppercase;padding:6px 14px;border-radius:100px;margin-bottom:20px;}',
        '.sc-exit-title{font-family:"Cormorant Garamond",Georgia,serif;font-size:36px;font-weight:400;',
          'line-height:1.15;letter-spacing:-0.02em;color:#1A1816;margin:0 0 12px;}',
        '.sc-exit-title em{font-style:italic;color:#8A6E48;}',
        '.sc-exit-sub{font-family:"Inter",sans-serif;font-size:15px;color:#7A756E;line-height:1.6;margin:0 0 28px;}',
        '.sc-exit-cta{display:flex;flex-direction:column;gap:10px;}',
        '.sc-exit-btn-primary{display:block;background:#0D0C0B;color:#F8F5F0;font-family:"Inter",sans-serif;',
          'font-size:14px;font-weight:500;letter-spacing:0.04em;padding:15px 28px;border-radius:100px;',
          'text-decoration:none;transition:all 200ms;}',
        '.sc-exit-btn-primary:hover{background:#2A2520;color:#F8F5F0;}',
        '.sc-exit-btn-skip{font-family:"Inter",sans-serif;font-size:13px;color:#7A756E;',
          'background:none;border:none;cursor:pointer;text-decoration:underline;padding:4px;}',
        '@keyframes scFadeIn{from{opacity:0}to{opacity:1}}',
        '@keyframes scSlideUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}',
      ].join('');
      document.head.appendChild(s);

      overlay.innerHTML = [
        '<div id="sc-exit-modal">',
          '<button id="sc-exit-close" aria-label="Luk">',
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
          '</button>',
          '<div class="sc-exit-badge">Gratis etui inkluderet</div>',
          '<h2 class="sc-exit-title">Din første designerduft<br><em>fra kun 119 kr/md</em></h2>',
          '<p class="sc-exit-sub">Over 8.000+ medlemmer er allerede med. Prøv uden binding, opsig når du vil.</p>',
          '<div class="sc-exit-cta">',
            '<a href="' + pricingUrl + '" class="sc-exit-btn-primary sc-track-cta" data-cta="exit-intent">Ja tak, vis mig planerne →</a>',
            '<button class="sc-exit-btn-skip" id="sc-exit-skip">Nej tak, måske senere</button>',
          '</div>',
        '</div>',
      ].join('');

      document.body.appendChild(overlay);

      function close() {
        overlay.style.opacity = '0';
        overlay.style.transition = 'opacity 200ms';
        setTimeout(function () {
          if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
        }, 200);
        sessionStorage.setItem('sc_exit_shown', '1');
      }

      document.getElementById('sc-exit-close').addEventListener('click', close);
      document.getElementById('sc-exit-skip').addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 5 && !triggered) {
        triggered = true;
        injectPopup();
      }
    });
  }

  /* ── Smooth anchor scrolling ── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.section-header') || document.querySelector('header');
        var offset = header ? header.offsetHeight + 16 : 80;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* ── Init ── */
  function isSubscriptionFlow() {
    return document.body.classList.contains('scenty-subscription-flow');
  }

  function init() {
    initReveal();
    initSmoothScroll();
    initCtaTracking();

    if (isSubscriptionFlow()) return;

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        showProofToasts();
        initExitIntent();
      }, { timeout: 3000 });
    } else {
      setTimeout(function () {
        showProofToasts();
        initExitIntent();
      }, 2000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
